import axios from '../utils/request/request'
const template = {
    // 登录
    templateList: params => axios.post('/frontend/chat/templatelist', params),
    // 详情
    templateDetail: params => axios.post('/frontend/chat/templatedetail', params)
}
export default template